type Callback = (args: any) => void
type Subscriptions = {
  [key: string]: Array<Callback>
}

import { makeRootDialogEvent } from '../utils/events'

const makeEvent = makeRootDialogEvent

export class DialogControllerInternal {
  static useInternal() {
    const { $root } = useNuxtApp()

    function show(targetId: string, args?: any) {
      trigger('show', targetId, args)
    }

    function hide(targetId: string, args?: any) {
      trigger('hide', targetId, args)
    }

    function ok(targetId: string, args?: any) {
      trigger('ok', targetId, args)
    }

    function cancel(targetId: string, args?: any) {
      trigger('cancel', targetId, args)
    }

    function trigger(ev: string, targetId: string, args?: any) {
      // @ts-ignore
      $root.emit(`trigger:${makeEvent(ev, targetId)}`, args)
    }

    return {
      show,
      hide,
      ok,
      cancel
    }
  }
}

export class DialogController {
  static use() {
    const subscriptions: Subscriptions = {}
    const { $root } = useNuxtApp()

    function onShow(targetId: string, callback: Callback) {
      subscribe('show', targetId, callback)
    }

    function onShown(targetId: string, callback: Callback) {
      subscribe('shown', targetId, callback)
    }

    function onHide(targetId: string, callback: Callback) {
      subscribe('hide', targetId, callback)
    }

    function onHidden(targetId: string, callback: Callback) {
      subscribe('hidden', targetId, callback)
    }

    function onOk(targetId: string, callback: Callback) {
      subscribe('ok', targetId, callback)
    }

    function onCancel(targetId: string, callback: Callback) {
      subscribe('cancel', targetId, callback)
    }

    function subscribe(ev: string, targetId: string, callback: Callback) {
      const event = makeEvent(ev, targetId)

      ;(subscriptions[event] || (subscriptions[event] = [])).push(callback)
      // @ts-ignore
      $root.on(event, callback)
    }

    onScopeDispose(() => {
      Object.entries(subscriptions).forEach(([key, callbacks]) => {
        callbacks.forEach((cb) => {
          // @ts-ignore
          $root.off(key, cb)
        })

        delete subscriptions[key]
      })
    })

    return {
      ...DialogControllerInternal.useInternal(),
      onShow,
      onShown,
      onHide,
      onHidden,
      onOk,
      onCancel,
      subscribe
    }
  }
}
